import styled from '@emotion/styled'
import { typography, spacer } from 'stylist'

const Subheader = styled.span`
  ${typography('subheading3')};
  margin-right: ${spacer(3)};
`
export default Subheader



// WEBPACK FOOTER //
// ./src/components/Subheader.js